import RemoveAllPage from "./RemoveAllPage";

export {RemoveAllPage}
export default RemoveAllPage
